import type { PronunciationWordSeed } from './types'

export const pronunciationWordSeeds: PronunciationWordSeed[] = [
  {
    id: 'word-mama',
    hanzi: '妈妈',
    pinyinNumber: 'ma1 ma5',
    meaning: 'mom',
    lessonIds: ['tones-vowels', 'bpmf'],
    level: 1
  },
  {
    id: 'word-baba',
    hanzi: '爸爸',
    pinyinNumber: 'ba4 ba5',
    meaning: 'dad',
    lessonIds: ['tones-vowels', 'bpmf'],
    level: 1
  },
  {
    id: 'word-ma-question',
    hanzi: '吗',
    pinyinNumber: 'ma5',
    meaning: 'question particle',
    lessonIds: ['tones-vowels', 'tones'],
    level: 1
  },
  {
    id: 'word-horse',
    hanzi: '马',
    pinyinNumber: 'ma3',
    meaning: 'horse',
    lessonIds: ['tones-vowels', 'tones'],
    confusionTags: ['confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-one',
    hanzi: '一',
    pinyinNumber: 'yi1',
    meaning: 'one',
    lessonIds: ['tones-vowels'],
    level: 1
  },
  {
    id: 'word-two',
    hanzi: '二',
    pinyinNumber: 'er4',
    meaning: 'two',
    lessonIds: ['tones-vowels'],
    level: 1
  },
  {
    id: 'word-five',
    hanzi: '五',
    pinyinNumber: 'wu3',
    meaning: 'five',
    lessonIds: ['tones-vowels'],
    level: 1
  },
  {
    id: 'word-rice',
    hanzi: '米饭',
    pinyinNumber: 'mi3 fan4',
    meaning: 'cooked rice',
    lessonIds: ['tones-vowels', 'bpmf'],
    level: 1
  },
  {
    id: 'word-touch',
    hanzi: '摸',
    pinyinNumber: 'mo1',
    meaning: 'to touch',
    lessonIds: ['tones-vowels', 'bpmf'],
    level: 3,
    audioPath: '/audio/cmn/64k/syllabs/cmn-mo1.mp3'
  },
  {
    id: 'word-eight',
    hanzi: '八',
    pinyinNumber: 'ba1',
    meaning: 'eight',
    lessonIds: ['bpmf'],
    level: 1
  },
  {
    id: 'word-no',
    hanzi: '不',
    pinyinNumber: 'bu4',
    meaning: 'not; no',
    lessonIds: ['bpmf'],
    level: 1
  },
  {
    id: 'word-friend',
    hanzi: '朋友',
    pinyinNumber: 'peng2 you5',
    meaning: 'friend',
    lessonIds: ['bpmf', 'nasals'],
    confusionTags: ['confusion-en-eng'],
    level: 2
  },
  {
    id: 'word-minute',
    hanzi: '分',
    pinyinNumber: 'fen1',
    meaning: 'minute; point',
    lessonIds: ['bpmf'],
    level: 1
  },
  {
    id: 'word-fly',
    hanzi: '飞',
    pinyinNumber: 'fei1',
    meaning: 'to fly',
    lessonIds: ['bpmf'],
    level: 2
  },
  {
    id: 'word-door',
    hanzi: '门',
    pinyinNumber: 'men2',
    meaning: 'door',
    lessonIds: ['bpmf'],
    level: 1
  },
  {
    id: 'word-ticket',
    hanzi: '票',
    pinyinNumber: 'piao4',
    meaning: 'ticket',
    lessonIds: ['bpmf'],
    level: 2
  },
  {
    id: 'word-you',
    hanzi: '你',
    pinyinNumber: 'ni3',
    meaning: 'you',
    lessonIds: ['dtnl'],
    level: 1
  },
  {
    id: 'word-he',
    hanzi: '他',
    pinyinNumber: 'ta1',
    meaning: 'he; him',
    lessonIds: ['dtnl'],
    level: 1
  },
  {
    id: 'word-she',
    hanzi: '她',
    pinyinNumber: 'ta1',
    meaning: 'she; her',
    lessonIds: ['dtnl'],
    level: 1
  },
  {
    id: 'word-come',
    hanzi: '来',
    pinyinNumber: 'lai2',
    meaning: 'to come',
    lessonIds: ['dtnl'],
    level: 1
  },
  {
    id: 'word-teacher',
    hanzi: '老师',
    pinyinNumber: 'lao3 shi1',
    meaning: 'teacher',
    lessonIds: ['dtnl'],
    confusionTags: ['confusion-zhchshr'],
    level: 1
  },
  {
    id: 'word-too',
    hanzi: '太',
    pinyinNumber: 'tai4',
    meaning: 'too; very',
    lessonIds: ['dtnl'],
    level: 1
  },
  {
    id: 'word-all',
    hanzi: '都',
    pinyinNumber: 'dou1',
    meaning: 'all; both',
    lessonIds: ['dtnl'],
    level: 1
  },
  {
    id: 'word-buy',
    hanzi: '买',
    pinyinNumber: 'mai3',
    meaning: 'to buy',
    lessonIds: ['dtnl', 'tones'],
    confusionTags: ['confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-sell',
    hanzi: '卖',
    pinyinNumber: 'mai4',
    meaning: 'to sell',
    lessonIds: ['dtnl', 'tones'],
    level: 1
  },
  {
    id: 'word-tall',
    hanzi: '高',
    pinyinNumber: 'gao1',
    meaning: 'tall; high',
    lessonIds: ['gkh'],
    level: 1
  },
  {
    id: 'word-older-brother',
    hanzi: '哥哥',
    pinyinNumber: 'ge1 ge5',
    meaning: 'older brother',
    lessonIds: ['gkh'],
    level: 1
  },
  {
    id: 'word-can',
    hanzi: '可以',
    pinyinNumber: 'ke3 yi3',
    meaning: 'can; may',
    lessonIds: ['gkh'],
    confusionTags: ['confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-very',
    hanzi: '很',
    pinyinNumber: 'hen3',
    meaning: 'very',
    lessonIds: ['gkh'],
    confusionTags: ['confusion-en-eng', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-good',
    hanzi: '好',
    pinyinNumber: 'hao3',
    meaning: 'good',
    lessonIds: ['gkh'],
    confusionTags: ['confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-country',
    hanzi: '国家',
    pinyinNumber: 'guo2 jia1',
    meaning: 'country',
    lessonIds: ['gkh', 'mixed-review'],
    level: 2
  },
  {
    id: 'word-work',
    hanzi: '工作',
    pinyinNumber: 'gong1 zuo4',
    meaning: 'work; job',
    lessonIds: ['gkh', 'mixed-review'],
    confusionTags: ['confusion-zcs'],
    level: 2
  },
  {
    id: 'word-drink',
    hanzi: '喝',
    pinyinNumber: 'he1',
    meaning: 'to drink',
    lessonIds: ['gkh'],
    level: 1
  },
  {
    id: 'word-day',
    hanzi: '天',
    pinyinNumber: 'tian1',
    meaning: 'day; sky',
    lessonIds: ['gkh', 'nasals'],
    level: 1
  },
  {
    id: 'word-text',
    hanzi: '文',
    pinyinNumber: 'wen2',
    meaning: 'writing; language',
    lessonIds: ['gkh'],
    confusionTags: ['confusion-en-eng'],
    level: 2
  },
  {
    id: 'word-study-verb',
    hanzi: '学',
    pinyinNumber: 'xue2',
    meaning: 'to study; to learn',
    lessonIds: ['jqx', 'tones'],
    level: 1
  },
  {
    id: 'word-go',
    hanzi: '去',
    pinyinNumber: 'qu4',
    meaning: 'to go',
    lessonIds: ['jqx'],
    confusionTags: ['confusion-jqx', 'confusion-u-ü'],
    level: 1
  },
  {
    id: 'word-home',
    hanzi: '家',
    pinyinNumber: 'jia1',
    meaning: 'home; family',
    lessonIds: ['jqx'],
    confusionTags: ['confusion-jqx'],
    level: 1
  },
  {
    id: 'word-money',
    hanzi: '钱',
    pinyinNumber: 'qian2',
    meaning: 'money',
    lessonIds: ['jqx'],
    confusionTags: ['confusion-jqx'],
    level: 1
  },
  {
    id: 'word-small',
    hanzi: '小',
    pinyinNumber: 'xiao3',
    meaning: 'small',
    lessonIds: ['jqx'],
    confusionTags: ['confusion-jqx', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-thanks',
    hanzi: '谢谢',
    pinyinNumber: 'xie4 xie5',
    meaning: 'thank you',
    lessonIds: ['jqx'],
    confusionTags: ['confusion-jqx'],
    level: 1
  },
  {
    id: 'word-call',
    hanzi: '叫',
    pinyinNumber: 'jiao4',
    meaning: 'to be called; to call',
    lessonIds: ['jqx'],
    confusionTags: ['confusion-jqx'],
    level: 1
  },
  {
    id: 'word-like',
    hanzi: '喜欢',
    pinyinNumber: 'xi3 huan5',
    meaning: 'to like',
    lessonIds: ['jqx'],
    confusionTags: ['confusion-jqx', 'confusion-u-ü'],
    level: 1
  },
  {
    id: 'word-today',
    hanzi: '今天',
    pinyinNumber: 'jin1 tian1',
    meaning: 'today',
    lessonIds: ['jqx', 'mixed-review'],
    level: 1
  },
  {
    id: 'word-please',
    hanzi: '请',
    pinyinNumber: 'qing3',
    meaning: 'please; to invite',
    lessonIds: ['jqx'],
    confusionTags: ['confusion-jqx', 'confusion-en-eng', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-seven',
    hanzi: '七',
    pinyinNumber: 'qi1',
    meaning: 'seven',
    lessonIds: ['jqx'],
    confusionTags: ['confusion-jqx'],
    level: 1
  },
  {
    id: 'word-nine',
    hanzi: '九',
    pinyinNumber: 'jiu3',
    meaning: 'nine',
    lessonIds: ['jqx'],
    confusionTags: ['confusion-jqx', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-at',
    hanzi: '在',
    pinyinNumber: 'zai4',
    meaning: 'at; in; to exist',
    lessonIds: ['zcs'],
    confusionTags: ['confusion-zcs'],
    level: 1
  },
  {
    id: 'word-again',
    hanzi: '再',
    pinyinNumber: 'zai4',
    meaning: 'again',
    lessonIds: ['zcs'],
    confusionTags: ['confusion-zcs'],
    level: 1
  },
  {
    id: 'word-vegetable',
    hanzi: '菜',
    pinyinNumber: 'cai4',
    meaning: 'vegetable; dish',
    lessonIds: ['zcs'],
    confusionTags: ['confusion-zcs'],
    level: 1
  },
  {
    id: 'word-three',
    hanzi: '三',
    pinyinNumber: 'san1',
    meaning: 'three',
    lessonIds: ['zcs'],
    confusionTags: ['confusion-zcs', 'confusion-an-ang'],
    level: 1
  },
  {
    id: 'word-four',
    hanzi: '四',
    pinyinNumber: 'si4',
    meaning: 'four',
    lessonIds: ['zcs'],
    confusionTags: ['confusion-zcs'],
    level: 1
  },
  {
    id: 'word-word',
    hanzi: '词',
    pinyinNumber: 'ci2',
    meaning: 'word',
    lessonIds: ['zcs'],
    confusionTags: ['confusion-zcs'],
    level: 2
  },
  {
    id: 'word-early',
    hanzi: '早',
    pinyinNumber: 'zao3',
    meaning: 'early',
    lessonIds: ['zcs'],
    confusionTags: ['confusion-zcs', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-sit',
    hanzi: '坐',
    pinyinNumber: 'zuo4',
    meaning: 'to sit',
    lessonIds: ['zcs'],
    confusionTags: ['confusion-zcs'],
    level: 1
  },
  {
    id: 'word-walk',
    hanzi: '走',
    pinyinNumber: 'zou3',
    meaning: 'to walk',
    lessonIds: ['zcs'],
    confusionTags: ['confusion-zcs', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-character',
    hanzi: '字',
    pinyinNumber: 'zi4',
    meaning: 'character; written word',
    lessonIds: ['zcs'],
    confusionTags: ['confusion-zcs'],
    level: 1
  },
  {
    id: 'word-be',
    hanzi: '是',
    pinyinNumber: 'shi4',
    meaning: 'to be',
    lessonIds: ['zhchshr'],
    confusionTags: ['confusion-zhchshr'],
    level: 1
  },
  {
    id: 'word-person',
    hanzi: '人',
    pinyinNumber: 'ren2',
    meaning: 'person',
    lessonIds: ['zhchshr'],
    confusionTags: ['confusion-zhchshr', 'confusion-en-eng'],
    level: 1
  },
  {
    id: 'word-eat',
    hanzi: '吃',
    pinyinNumber: 'chi1',
    meaning: 'to eat',
    lessonIds: ['zhchshr'],
    confusionTags: ['confusion-zhchshr'],
    level: 1
  },
  {
    id: 'word-book',
    hanzi: '书',
    pinyinNumber: 'shu1',
    meaning: 'book',
    lessonIds: ['zhchshr'],
    confusionTags: ['confusion-zhchshr', 'confusion-u-ü'],
    level: 1
  },
  {
    id: 'word-hot',
    hanzi: '热',
    pinyinNumber: 're4',
    meaning: 'hot',
    lessonIds: ['zhchshr'],
    confusionTags: ['confusion-zhchshr'],
    level: 1
  },
  {
    id: 'word-this',
    hanzi: '这',
    pinyinNumber: 'zhe4',
    meaning: 'this',
    lessonIds: ['zhchshr'],
    confusionTags: ['confusion-zhchshr'],
    level: 1
  },
  {
    id: 'word-car',
    hanzi: '车',
    pinyinNumber: 'che1',
    meaning: 'car',
    lessonIds: ['zhchshr'],
    confusionTags: ['confusion-zhchshr'],
    level: 1
  },
  {
    id: 'word-mountain',
    hanzi: '山',
    pinyinNumber: 'shan1',
    meaning: 'mountain',
    lessonIds: ['zhchshr'],
    confusionTags: ['confusion-zhchshr', 'confusion-an-ang'],
    level: 1
  },
  {
    id: 'word-up',
    hanzi: '上',
    pinyinNumber: 'shang4',
    meaning: 'up; above',
    lessonIds: ['zhchshr'],
    confusionTags: ['confusion-zhchshr', 'confusion-an-ang'],
    level: 1
  },
  {
    id: 'word-chinese-language',
    hanzi: '中文',
    pinyinNumber: 'zhong1 wen2',
    meaning: 'Chinese language',
    lessonIds: ['zhchshr', 'mixed-review'],
    confusionTags: ['confusion-zhchshr', 'confusion-en-eng'],
    level: 1
  },
  {
    id: 'word-hanzi',
    hanzi: '汉字',
    pinyinNumber: 'han4 zi4',
    meaning: 'Chinese characters',
    lessonIds: ['zhchshr', 'mixed-review'],
    confusionTags: ['confusion-zcs', 'confusion-an-ang'],
    level: 1
  },
  {
    id: 'word-water',
    hanzi: '水',
    pinyinNumber: 'shui3',
    meaning: 'water',
    lessonIds: ['nasals'],
    confusionTags: ['confusion-zhchshr', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-think',
    hanzi: '想',
    pinyinNumber: 'xiang3',
    meaning: 'to think; to want',
    lessonIds: ['nasals'],
    confusionTags: ['confusion-jqx', 'confusion-an-ang', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-listen',
    hanzi: '听',
    pinyinNumber: 'ting1',
    meaning: 'to listen',
    lessonIds: ['nasals'],
    confusionTags: ['confusion-en-eng'],
    level: 1
  },
  {
    id: 'word-name',
    hanzi: '名字',
    pinyinNumber: 'ming2 zi5',
    meaning: 'name',
    lessonIds: ['nasals'],
    confusionTags: ['confusion-en-eng', 'confusion-zcs'],
    level: 1
  },
  {
    id: 'word-tomorrow',
    hanzi: '明天',
    pinyinNumber: 'ming2 tian1',
    meaning: 'tomorrow',
    lessonIds: ['nasals', 'mixed-review'],
    confusionTags: ['confusion-en-eng'],
    level: 1
  },
  {
    id: 'word-student',
    hanzi: '学生',
    pinyinNumber: 'xue2 sheng5',
    meaning: 'student',
    lessonIds: ['nasals'],
    confusionTags: ['confusion-jqx', 'confusion-zhchshr', 'confusion-en-eng'],
    level: 1
  },
  {
    id: 'word-mandarin',
    hanzi: '汉语',
    pinyinNumber: 'han4 yu3',
    meaning: 'Mandarin Chinese',
    lessonIds: ['nasals'],
    confusionTags: ['confusion-an-ang', 'confusion-u-ü', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-last-year',
    hanzi: '去年',
    pinyinNumber: 'qu4 nian2',
    meaning: 'last year',
    lessonIds: ['nasals'],
    confusionTags: ['confusion-jqx', 'confusion-u-ü', 'confusion-an-ang'],
    level: 1
  },
  {
    id: 'word-cloud',
    hanzi: '云',
    pinyinNumber: 'yun2',
    meaning: 'cloud',
    lessonIds: ['nasals'],
    confusionTags: ['confusion-u-ü', 'confusion-en-eng'],
    level: 2
  },
  {
    id: 'word-daughter',
    hanzi: '女儿',
    pinyinNumber: 'nü3 er2',
    meaning: 'daughter',
    lessonIds: ['nasals'],
    confusionTags: ['confusion-u-ü', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-bank',
    hanzi: '银行',
    pinyinNumber: 'yin2 hang2',
    meaning: 'bank',
    lessonIds: ['nasals'],
    confusionTags: ['confusion-an-ang', 'confusion-en-eng'],
    level: 2
  },
  {
    id: 'word-moon',
    hanzi: '月',
    pinyinNumber: 'yue4',
    meaning: 'moon; month',
    lessonIds: ['tones'],
    confusionTags: ['confusion-u-ü'],
    level: 1
  },
  {
    id: 'word-far',
    hanzi: '远',
    pinyinNumber: 'yuan3',
    meaning: 'far',
    lessonIds: ['tones'],
    confusionTags: ['confusion-u-ü', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-america',
    hanzi: '美国',
    pinyinNumber: 'mei3 guo2',
    meaning: 'United States',
    lessonIds: ['tones', 'mixed-review'],
    confusionTags: ['confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-what',
    hanzi: '什么',
    pinyinNumber: 'shen2 me5',
    meaning: 'what',
    lessonIds: ['tones'],
    confusionTags: ['confusion-zhchshr', 'confusion-en-eng'],
    level: 1
  },
  {
    id: 'word-where',
    hanzi: '哪里',
    pinyinNumber: 'na3 li3',
    meaning: 'where',
    lessonIds: ['tones'],
    confusionTags: ['confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-who',
    hanzi: '谁',
    pinyinNumber: 'shei2',
    meaning: 'who',
    lessonIds: ['tones'],
    confusionTags: ['confusion-zhchshr'],
    level: 1
  },
  {
    id: 'word-goodbye',
    hanzi: '再见',
    pinyinNumber: 'zai4 jian4',
    meaning: 'goodbye',
    lessonIds: ['mixed-review'],
    confusionTags: ['confusion-zcs', 'confusion-jqx', 'confusion-an-ang'],
    level: 1
  },
  {
    id: 'word-school',
    hanzi: '学校',
    pinyinNumber: 'xue2 xiao4',
    meaning: 'school',
    lessonIds: ['mixed-review'],
    confusionTags: ['confusion-jqx', 'confusion-u-ü'],
    level: 1
  },
  {
    id: 'word-study',
    hanzi: '学习',
    pinyinNumber: 'xue2 xi2',
    meaning: 'to study',
    lessonIds: ['mixed-review'],
    confusionTags: ['confusion-jqx', 'confusion-u-ü'],
    level: 1
  },
  {
    id: 'word-restaurant',
    hanzi: '饭店',
    pinyinNumber: 'fan4 dian4',
    meaning: 'restaurant; hotel',
    lessonIds: ['mixed-review'],
    confusionTags: ['confusion-an-ang'],
    level: 1
  },
  {
    id: 'word-computer',
    hanzi: '电脑',
    pinyinNumber: 'dian4 nao3',
    meaning: 'computer',
    lessonIds: ['mixed-review'],
    confusionTags: ['confusion-an-ang', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-apple',
    hanzi: '苹果',
    pinyinNumber: 'ping2 guo3',
    meaning: 'apple',
    lessonIds: ['mixed-review'],
    confusionTags: ['confusion-en-eng', 'confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-tea',
    hanzi: '茶',
    pinyinNumber: 'cha2',
    meaning: 'tea',
    lessonIds: ['mixed-review'],
    confusionTags: ['confusion-zhchshr'],
    level: 1
  },
  {
    id: 'word-coffee',
    hanzi: '咖啡',
    pinyinNumber: 'ka1 fei1',
    meaning: 'coffee',
    lessonIds: ['mixed-review'],
    level: 1
  },
  {
    id: 'word-cat',
    hanzi: '猫',
    pinyinNumber: 'mao1',
    meaning: 'cat',
    lessonIds: ['mixed-review'],
    level: 1
  },
  {
    id: 'word-dog',
    hanzi: '狗',
    pinyinNumber: 'gou3',
    meaning: 'dog',
    lessonIds: ['mixed-review'],
    confusionTags: ['confusion-tone-2-3'],
    level: 1
  },
  {
    id: 'word-weather',
    hanzi: '天气',
    pinyinNumber: 'tian1 qi4',
    meaning: 'weather',
    lessonIds: ['mixed-review'],
    confusionTags: ['confusion-jqx', 'confusion-an-ang'],
    level: 1
  }
]
